import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShip"><Path d="M12.0009 11.4781L2.94928 13.6799C3.21202 15.7245 3.88177 17.2627 5.00381 18.9956L1.85938 19.6755L2.17637 21.1416L7.37594 20.0173L12.0009 21.0173L16.6259 20.0173L21.8255 21.1416L22.1425 19.6755L18.9981 18.9956C20.1201 17.2627 20.7898 15.7245 21.0526 13.6799L12.0009 11.4781Z" fill="currentColor"/><Path d="M9 2V6H5V11.6378L12.0028 9.93439L19 11.6364V6H15V2H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShip;
